import React, { useState, useEffect } from "react";
import { Box, Button } from "@mui/material";
import { Mail } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { reportsEmailTimeInterval } from "../../constants";
import { differenceInSeconds } from "date-fns";
import CountdownTimer from "../../components/Reports/countdownTimer";
import ReportsTable from "./reportsTable";
import EmailModal from "./emailModal";

const CustomerCartReport = () => {
  const [reportModal, setReportModal] = useState<boolean>(false);
  const [disableMailBtn, setDisableMailBtn] = useState(false);
  const [timeRemaining, setTimeRemaining] = useState(0);

  const customerCartEmailTime_Store = useSelector(
    (state: any) => state.reportTime.customerCart
  );

  useEffect(() => {
    if (
      customerCartEmailTime_Store != null &&
      customerCartEmailTime_Store !== ""
    ) {
      const secondsDiff = differenceInSeconds(
        new Date(),
        new Date(customerCartEmailTime_Store)
      );
      if (secondsDiff > reportsEmailTimeInterval) {
        setDisableMailBtn(false);
      } else {
        setDisableMailBtn(true);
        if (reportsEmailTimeInterval - secondsDiff > 0) {
          setTimeRemaining(reportsEmailTimeInterval - secondsDiff);
        }
      }
    }
  }, [customerCartEmailTime_Store]);

  return (
    <>
      <Box>
        <Button
          variant="contained"
          color="primary"
          sx={{ float: "right" }}
          startIcon={<Mail />}
          onClick={() => setReportModal(!reportModal)}
          disabled={disableMailBtn}
        >
          Mail Report{" "}
          {disableMailBtn ? (
            <CountdownTimer
              timeRemaining={timeRemaining}
              setDisableMailBtn={setDisableMailBtn}
            />
          ) : (
            ""
          )}
        </Button>
      </Box>
      <Box sx={{ mt: { xs: 6.5, md: 7.5 } }}>
        <ReportsTable reportType="customer_cart_report" />
      </Box>
      <EmailModal
        reportModal={reportModal}
        setReportModal={setReportModal}
        setTimeRemaining={setTimeRemaining}
        reportType="customer_cart_report"
      />
    </>
  );
};

export default CustomerCartReport;
